import BaseAPI from './base.api.service'

const resource = 'misccosts';
export default {
    async getMiscCost(erID) {
        return await BaseAPI.get(`expensereports/${erID}/MiscCost`);
    },
    async getMiscCostTypes() {
        return await BaseAPI.get(`${resource}/Types`);
    }
} 